import { ScreenSizeDetector } from '@skand/utils';
import { featureFlagController } from './featureFlags';

export const screenSizeDetector = new ScreenSizeDetector({ featureFlagController });
screenSizeDetector.start();
